import React from 'react';

export default () => {
    return (
        <>
            <p>Here is CustomerDataFields.Home</p>
        </>
    )
}